import { PALETTE, BRAND_DELIVERABLES, IMAGES } from "../content";
import { Reveal } from "../motion";
import { Section, Wrap, SectionHead, Eyebrow } from "./Section";
import { useLightbox } from "./Lightbox";

export default function BrandTerritory() {
  const openLightbox = useLightbox();
  return (
    <Section id="brand" theme="neutral" className="py-16 sm:py-24">
      <Wrap>
        <SectionHead
          eyebrow="Brand and marketing foundation"
          title="A proposed visual territory, not a finished identity."
          intro="The final brand will be developed together after appointment. This board shows the territory we believe it should inhabit."
        />

        <div className="grid lg:grid-cols-12 gap-6 mt-10 sm:mt-12">
          <Reveal className="lg:col-span-7">
            <div className="grid grid-cols-3 sm:grid-cols-6 lg:grid-cols-3 gap-3">
              {PALETTE.map((c, i) => (
                <Reveal key={c.hex} delay={i * 0.4}>
                  <div className="group cursor-default">
                    <div
                      className="h-24 sm:h-32 rounded-2xl transition-transform duration-500 group-hover:-translate-y-1.5 border border-[#242424]/10"
                      style={{ backgroundColor: c.hex }}
                    />
                    <p className="text-[10px] font-semibold uppercase tracking-[0.14em] text-[#242424]/70 mt-2.5">{c.name}</p>
                    <p className="text-[10px] text-[#242424]/40 font-mono">{c.hex}</p>
                  </div>
                </Reveal>
              ))}
            </div>
          </Reveal>

          <Reveal delay={2} className="lg:col-span-5">
            <div className="bg-[#26342E] text-[#F6F0E6] rounded-3xl p-8 sm:p-10 h-full flex flex-col justify-between">
              <div>
                <p className="font-serif text-4xl sm:text-5xl font-light leading-tight">Aa</p>
                <p className="font-serif italic text-lg text-[#F6F0E6]/70 mt-1">Cormorant Garamond, a calm editorial voice</p>
                <p className="font-sans text-2xl font-semibold mt-6 tracking-tight">Aa</p>
                <p className="text-sm text-[#F6F0E6]/60 mt-1">Plus Jakarta Sans, clear digital navigation</p>
              </div>
              <p className="text-xs leading-relaxed text-[#F6F0E6]/50 mt-8 border-t border-[#F6F0E6]/10 pt-5">
                Natural South African light. Real texture, limewash, linen, pale wood. Dignity before drama.
              </p>
            </div>
          </Reveal>

          <Reveal delay={1} className="lg:col-span-5">
            <button
              data-testid="territory-photo"
              onClick={() => openLightbox("circle")}
              aria-label="View photograph: warm light, open conversation"
              className="relative block w-full rounded-3xl overflow-hidden h-64 lg:h-72 group cursor-pointer text-left"
            >
              <img
                src={IMAGES.circle}
                alt="A circle of people in warm, candid conversation, the photography direction for the proposed brand"
                className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-[1.04]"
                loading="lazy"
              />
              <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-[#26342E]/80 to-transparent p-6">
                <p className="text-[10px] font-bold uppercase tracking-[0.2em] text-[#F6F0E6]/85">Photography direction · tap to view</p>
                <p className="font-serif italic text-lg text-[#F6F0E6] mt-1">Candid listening, warm natural light, real connection.</p>
              </div>
            </button>
          </Reveal>

          <Reveal delay={2} className="lg:col-span-7">
            <div className="bg-white border border-[#242424]/10 rounded-3xl p-8 sm:p-10 h-full">
              <Eyebrow>Included in the foundation</Eyebrow>
              <ul className="mt-6 grid sm:grid-cols-2 gap-x-8 gap-y-3.5">
                {BRAND_DELIVERABLES.map((d) => (
                  <li key={d} className="flex items-start gap-3 text-sm text-[#242424]/75">
                    <span className="w-1.5 h-1.5 rounded-full bg-[#FFD400] mt-1.5 shrink-0 border border-[#242424]/20" />
                    {d}
                  </li>
                ))}
              </ul>
            </div>
          </Reveal>
        </div>
      </Wrap>
    </Section>
  );
}
